import { useTranslation } from 'react-i18next';
import type { TrialCustomerIdentity } from '../types/trialCustomerIdentity';
import { TrialCopyableId } from './TrialCopyableId';

interface TrialTechnicalIdsSectionProps {
  identity: TrialCustomerIdentity;
}

export function TrialTechnicalIdsSection({ identity }: TrialTechnicalIdsSectionProps) {
  const { t } = useTranslation();

  return (
    <section
      className="rounded-lg border border-dashed border-border bg-muted/10 p-3 space-y-2 min-w-0"
      aria-labelledby="trial-technical-ids-heading"
    >
      <h3
        id="trial-technical-ids-heading"
        className="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
      >
        {t('trials.detail.technicalIds')}
      </h3>
      <TrialCopyableId
        label={t('trials.identity.subscriptionId')}
        value={identity.subscriptionId}
      />
      <TrialCopyableId label={t('trials.identity.tenantId')} value={identity.tenantId} />
      <TrialCopyableId
        label={t('trials.identity.identityLinkId')}
        value={identity.identityLinkId}
      />
      {identity.source ? (
        <div className="flex items-center justify-between gap-2 pt-1 border-t border-border/60">
          <span className="text-xs font-medium text-muted-foreground">
            {t('trials.identity.source')}
          </span>
          <span className="text-xs text-foreground">{identity.source}</span>
        </div>
      ) : null}
    </section>
  );
}
